module.exports = __webpack_public_path__ + "static/img/8.732d6f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/3/zh/8.png
// module id = KfSm
// module chunks = 0